// Shared compiled patterns — module-level singletons reused by all rule instances.
// Private to this module; consumers receive them via the builder return values.
const noSlashRe = /[/\\]/
const notApplicableRe =
  /(^Not Applicable$)|(^N\/A$)|(^NA$)|(^N\.A\.$)|(^null$)/i
const emptyValueRe = /^\s*$/

/**
 * Rule: value length must not exceed `limit` characters.
 * @param {number} limit
 * @returns {{ re: RegExp, error: string }}
 */
export function buildMaxCharRule(limit) {
  return {
    re: new RegExp(`^.{${limit + 1},}$`),
    error: `Maximum length exceeded - must be ${limit} characters or less`,
  }
}

/**
 * Rule: value must not contain a forward slash or backslash.
 * @param {string} fieldLabel - Display name inserted into the error (e.g. 'Recordkeeper')
 * @returns {{ re: RegExp, error: string }}
 */
export function buildNoSlashRule(fieldLabel) {
  return {
    re: noSlashRe,
    error: `Please enter a valid ${fieldLabel}. No slashes allowed.`,
  }
}

/**
 * Rule: value must not be blank or whitespace-only.
 * @param {string} fieldName - Display name inserted into the error (e.g. 'First name')
 * @returns {{ re: RegExp, error: string }}
 */
export function buildEmptyValueRule(fieldName) {
  return {
    re: emptyValueRe,
    error: `Invalid, ${fieldName} is required`,
  }
}

/**
 * Rule: value must not be a "not applicable" variant (N/A, NA, null, Not Applicable, etc.).
 * @param {string} [errorMessage='Required']
 * @returns {{ re: RegExp, error: string }}
 */
export function buildNotApplicableRule(errorMessage = 'Required') {
  return {
    re: notApplicableRe,
    error: errorMessage,
  }
}
